// Left panel: BOM cart table + totals for ProductionOrder
import { Row, Col, Table, Input } from "antd";
import { CloseSquareFilled } from "@ant-design/icons";
import { toFixedTruncate } from "./productionUtils";
import SearchIcon from "../../assets/images/searchIcon.svg";
import "../PointOfSale/Retail/styles.css";

const CartSection = ({
  inputSearchRef,
  productSearchInput,
  setProductSearchInput,
  searchedProduct,
  setSearchedProduct,
  hasReverseOrderData,
  disableSearch,
  posConfig,
  selectedRowKey,
  setSelectedRowKey,
  showInputFields,
  setShowInputFields,
  setQtyShowInputFields,
  setSelectedQuantity,
  setSelectedTotalQuantity,
  setSelectedKey,
  setIsNewInput,
  activeTabKey,
  qtyInputRef,
  totalQtyRef,
  bomCartColumns,
  searchedProductsData,
  totalItems,
  totalQty,
  subtotal,
  currenciesList,
  pricePrecision,
  totalSalePrice,
  totalWeights,
}) => {
  return (
    <div style={{ width: "63.9%" }}>
      <div style={{ display: "flex", width: "100%", padding: "0 0 0 1.7%" }}>
        <div style={{ width: "98.3%" }}>
          <Input
            ref={inputSearchRef}
            placeholder="Search for products by code/name"
            id="sm-product-search"
            className="bomSearch-sm"
            style={{ borderRadius: "7px", padding: "0.8vh 0.8vw", borderColor: "#fff", border: "1px solid #ccc" }}
            suffix={
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                {productSearchInput.length > 0 ? <CloseSquareFilled style={{ fontSize: "20px", color: "#2F3856" }} onClick={() => setProductSearchInput("")} /> : null}
              </div>
            }
            prefix={<img src={SearchIcon} alt="" />}
            value={searchedProduct}
            onChange={(ev) => {
              setSearchedProduct(ev.target.value);
              localStorage.setItem("productName", ev.target.value);
            }}
            disabled={hasReverseOrderData || disableSearch}
          />
        </div>
      </div>
      <div style={{ padding: "1.5%" }}>
        {hasReverseOrderData ? (
          <div style={{ position: "absolute", bottom: "29vh", left: "52vw" }}>
            <span style={{ opacity: "0.8", color: "red", fontSize: "25px" }}>REVERSE</span>
          </div>
        ) : null}
        <Table
          className="sm-cart-table-pos"
          tableLayout="fixed"
          style={{
            width: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            border: "none",
            borderRadius: "7px",
            padding: "0px 7px",
            height: posConfig?.showOrderUnitPrice === "Y" ? "57vh" : "50.5vh",
            background: "#fff",
            fontSize: "0.78rem",
            pointerEvents: hasReverseOrderData ? "none" : "auto",
          }}
          pagination={false}
          sticky
          id="sm-cart-table"
          onRow={(record) => ({
            onClick: () => {
              if (!hasReverseOrderData) {
                if (selectedRowKey === record.key) {
                  setQtyShowInputFields(false);
                  setShowInputFields(!showInputFields);
                  if (showInputFields) {
                    requestAnimationFrame(() => {
                      if (activeTabKey === "1" && qtyInputRef?.current) {
                        qtyInputRef.current.focus();
                        qtyInputRef.current.select();
                      } else if (activeTabKey === "2" && totalQtyRef?.current) {
                        totalQtyRef.current.focus();
                        totalQtyRef.current.select();
                      }
                    });
                  }
                } else {
                  setSelectedQuantity(record.weight);
                  setSelectedTotalQuantity(record.totalWeight);
                  setSelectedKey(record.key);
                  setIsNewInput(true);
                  setShowInputFields(true);
                  setSelectedRowKey(record.key);
                  setQtyShowInputFields(false);
                  requestAnimationFrame(() => {
                    if (activeTabKey === "1" && qtyInputRef?.current) {
                      qtyInputRef.current.focus();
                      qtyInputRef.current.select();
                    } else if (activeTabKey === "2" && totalQtyRef?.current) {
                      totalQtyRef.current.focus();
                      totalQtyRef.current.select();
                    }
                  });
                }
              }
            },
          })}
          rowClassName={(record) => (selectedRowKey === record.key ? "tableRowSelectedBlue" : "tableRowNonSelectedWhite")}
          columns={bomCartColumns}
          dataSource={searchedProductsData}
          scroll={{ y: posConfig?.showOrderUnitPrice === "Y" ? "48vh" : "70vh" }}
        />
        {posConfig?.showOrderUnitPrice === "Y" ? null : (
          <>
            <Row style={{ height: "4.5vh", marginTop: "4vh", fontSize: "1vw" }}>
              <Col span={12} style={{ display: "flex", alignItems: "center", paddingLeft: "0.8vw", fontWeight: "500", textAlign: "left", fontSize: "1em" }}>
                <p style={{ display: "flex", alignItems: "center", color: "#0F0718", fontFamily: "Inter", fontWeight: 500, fontSize: "1em", marginBottom: 0 }}>Total Items:</p>
              </Col>
              <Col span={12} style={{ display: "flex", paddingRight: "0.8vw", textAlign: "right", justifyContent: "end", color: "#0F0718", fontFamily: "Inter", fontWeight: 500 }}>
                &nbsp;
                <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718", marginBottom: 0, fontSize: "1em" }}>{totalItems}</p>
                <span style={{ marginLeft: "2px" }}></span>
              </Col>
            </Row>
            <Row style={{ height: "4.5vh", fontSize: "1vw" }}>
              <Col span={12} style={{ display: "flex", alignItems: "center", paddingLeft: "0.8vw", fontWeight: "500", textAlign: "left", marginTop: "0.6vh" }}>
                <p style={{ display: "flex", alignItems: "center", color: "#0F0718", fontFamily: "Inter", fontWeight: 500, fontSize: "1em" }}>Total Qty:</p>
              </Col>
              <Col
                span={12}
                style={{ paddingRight: "0.8vw", textAlign: "right", justifyContent: "end", color: "#0F0718", marginTop: "0.6vh", fontFamily: "Inter", fontWeight: 500 }}
              >
                <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718", fontSize: "1em" }}>{toFixedTruncate(totalQty, 3)}</p>
              </Col>
            </Row>
          </>
        )}
      </div>
      {posConfig?.showOrderUnitPrice === "Y" ? (
        <div style={{ padding: "0 1.5% 0 1.5%", display: "flex" }}>
          <div style={{ background: "#fff", height: "23.5vh", width: "60%", marginRight: "1%", borderRadius: "7px", padding: "0.5vh", fontSize: "1vw", border: "1px solid #ccc" }}>
            {posConfig?.showSubTotal === "Y" && (
              <Row style={{ height: "4.5vh", fontSize: "1vw" }}>
                <Col span={12} style={{ display: "flex", alignItems: "center", paddingLeft: "0.8vw", textAlign: "left", fontWeight: "500", color: "#0F0718", marginTop: "2vh" }}>
                  <p style={{ display: "flex", alignItems: "center", color: "#0F0718", fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em" }}>Subtotal:</p>
                </Col>
                <Col
                  span={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    paddingRight: "0.8vw",
                    textAlign: "right",
                    justifyContent: "end",
                    color: "#0F0718",
                    fontSize: "1.2em",
                    fontFamily: "Inter",
                    fontWeight: 500,
                  }}
                >
                  &nbsp;
                  <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718" }}>
                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    {subtotal.toFixed(pricePrecision)}
                    <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
                  </p>
                </Col>
              </Row>
            )}
            <Row style={{ height: "4.5vh", marginTop: "4vh" }}>
              <Col span={12} style={{ display: "flex", alignItems: "center", paddingLeft: "0.8vw", fontWeight: "500", textAlign: "left" }}>
                <p style={{ display: "flex", alignItems: "center", color: "#0F0718", fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em" }}>Total Items:</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  paddingRight: "0.8vw",
                  textAlign: "right",
                  justifyContent: "end",
                  color: "#0F0718",
                  fontSize: "1.2em",
                  fontFamily: "Inter",
                  fontWeight: 500,
                }}
              >
                &nbsp;
                <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718" }}>{totalItems}</p>
                <span style={{ marginLeft: "2px" }}></span>
              </Col>
            </Row>
            <Row style={{ height: "4.5vh" }}>
              <Col span={12} style={{ display: "flex", alignItems: "center", paddingLeft: "0.8vw", fontWeight: "500", textAlign: "left", marginTop: "2vh" }}>
                <p style={{ display: "flex", alignItems: "center", color: "#0F0718", fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em" }}>Total Qty:</p>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingRight: "0.8vw",
                  textAlign: "right",
                  justifyContent: "end",
                  color: "#0F0718",
                  fontSize: "1.2em",
                  fontFamily: "Inter",
                  fontWeight: 500,
                }}
              >
                <p style={{ textAlign: "right", margin: "0", fontWeight: "500", color: "#0F0718" }}>{toFixedTruncate(totalQty, 3)}</p>
              </Col>
            </Row>
          </div>
          <div
            style={{ height: "23.7vh", width: "40%", fontSize: "1vw", border: "1px solid #ccc", borderRadius: "7px" }}
            onClick={() => {
              setSelectedRowKey(null);
              setShowInputFields(false);
              setQtyShowInputFields(false);
            }}
          >
            <div
              id="sm-cart-total"
              style={{
                height: "23.5vh",
                position: "relative",
                background: "#fff",
                borderRadius: "7px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "1vw",
              }}
            >
              <p style={{ padding: "0.7vw 0 0 1vw", color: "#0F0718", fontSize: "1.3em", fontWeight: "500", height: "4.5vh", paddingRight: "17vw" }}>Unit Price</p>
              <p style={{ color: "#0F0718", fontSize: "2.5em", fontWeight: 600, height: "14.4vh", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                {(totalSalePrice + totalWeights).toFixed(pricePrecision)}
                <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span>
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CartSection;
